import React, {useState, useEffect, useRef, useContext} from "react";
import khat from "../../Assets/images/Vector 37.png";
import "./AddToShoppingBag.scss";
import StarRating from "../StarRating/StarRating";
import {Link} from "react-router-dom";
import {toast} from "react-toastify";
import {formatToPersianAddComma} from "../../Utils/CommaSeparator";
import {SetSaleContext} from "../pages/Pages";

const AddToShoppingBag = ({productInfo}) => {
  const [heartColor, setHeartColor] = useState("#B9B9B9");
  const [bgHeartColor, setbgHeartColor] = useState("#FFFFFF");
  const [isFixed, setIsFixed] = useState(false);
  const buttonRef = useRef(null);
  const [currentNum, setCurrentNum] = useState(1);
  const [selectedamount, setSelectedamount] = useState(1);
  const setSaleNum = useContext(SetSaleContext);

  const numHandler = (data) => {
    let tp;
    if (productInfo.type === 1) {
      tp = 1;
    } else {
      tp = +productInfo.defultValue;
    }
    if (data === "up") {
      if (currentNum < +productInfo.inventory) {
        setCurrentNum((prevCount) => +prevCount + tp);
        setSelectedamount((prevAmount) => +prevAmount + tp);
      } else {
        toast.error("موجودی کافی نیست");
      }
    }

    if (data === "down") {
      if (currentNum > tp) {
        setCurrentNum((prevCount) => +prevCount - tp);
        setSelectedamount((prevAmount) => +prevAmount - tp);
      } else {
        toast.error("کمتر از این مقدار امکان پذیر نیست");
      }
    }
  };

  useEffect(() => {
    if (productInfo.type === 1) {
      setCurrentNum(1);
    } else {
      setCurrentNum(+productInfo.defultValue);
    }
  }, [productInfo]);

  const handleHeartClick = () => {
    const newColor = heartColor === "#B9B9B9" ? "#EB455F" : "#B9B9B9";
    const newBgColor = bgHeartColor === "#FFFFFF" ? "#EB455F" : "#FFFFFF";
    setHeartColor(newColor);
    setbgHeartColor(newBgColor);
  };

  const handleAddToCart = () => {
    if (selectedamount === "" || +selectedamount === 0) {
      toast.error("لطقا مقدار محصول را انتخاب کنید");
    } else {
      let pros =
        localStorage.getItem("products") !== ""
          ? JSON.parse(localStorage.getItem("products"))
          : [];
      if (pros.length === 0) {
        productInfo["count"] = currentNum;
        pros.push(productInfo);
      } else {
        const index = pros.findIndex((item) => item.id === productInfo.id);

        if (index !== -1) {
          pros[index].count = currentNum;
        } else {
          pros.push({...productInfo, count: currentNum});
        }
      }

      localStorage.setItem("products", JSON.stringify(pros));
      setSaleNum(currentNum);
      toast.success("محصول به سبد خرید اضافه شد.");
    }
  };

  return (
    <div className="leftFormProduct">
      <div className="formAddtoShoppingBag">
        <div className="topOfForm responsive_mrg">
          <span className="TiteltopOfForm">{productInfo?.title}</span>
          <div className="rowtopOfForm">
            <div className="righttopOfForm">
              <Link
                to={`/Group/SubGroups/${productInfo?.groupId}`}
                className="textrighttopOfForm"
              >
                {productInfo?.groupName}
              </Link>
              <span className="vector">|</span>
              <div className="Star">
                <StarRating rating={productInfo?.score}/>
              </div>
              <span className="quantityComment">
                ({productInfo?.comments.length} نظر)
              </span>
            </div>
            <div className="imgHeart">
              <div className="Hierarchy">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="25"
                  fill="none"
                  viewBox="0 0 24 25"
                >
                  <path
                    stroke="#B9B9B9"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                    d="M5 15.867v-7M5.25 22.867a3.25 3.25 0 100-6.5 3.25 3.25 0 000 6.5zM5 8.867a3 3 0 100-6 3 3 0 000 6zM19 8.867a3 3 0 100-6 3 3 0 000 6zM5.13 15.867a4.058 4.058 0 013.94-3.04l3.43.01c.85 0 1.67-.17 2.4-.49"
                  ></path>
                </svg>
              </div>
              <div className="imageHeart">
                <svg
                  width="24"
                  height="25"
                  viewBox="0 0 24 25"
                  fill={bgHeartColor}
                  xmlns="http://www.w3.org/2000/svg"
                  onClick={handleHeartClick}
                >
                  <path
                    d="M20.59 5.83665C21.47 6.82665 22 8.12665 22 9.55665C22 16.5567 15.52 20.6867 12.62 21.6867C12.28 21.8067 11.72 21.8067 11.38 21.6867C8.48 20.6867 2 16.5567 2 9.55665C2 6.46665 4.49 3.96665 7.56 3.96665C9.38 3.96665 10.99 4.84665 12 6.20665C13.01 4.84665 14.63 3.96665 16.44 3.96665"
                    stroke={heartColor}
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
          </div>
        </div>
        <div className="Khat">
          <img src={khat} alt={""}/>
        </div>

        <div className="rowProduct">
          {productInfo?.status ? (
            <div className="FormProduct">
              <div className="Description responsive_mrg">
                {productInfo?.features?.slice(0, 4).map((desc, index) => (
                  <div className="Descriptions" key={index}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="8"
                      height="9"
                      viewBox="0 0 8 9"
                      fill="none"
                    >
                      <circle cx="3.99902" cy="4.86667" r="4" fill="#40b2aa"/>
                    </svg>
                    {desc.key}: {desc.value}
                  </div>
                ))}
              </div>
              <div className="responsive responsive_mrg">
                <div className="columnResponsive">
                  <div className="PossibilityOfPayment">
                    <div className="imagePossibilityOfPayment">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="none"
                        viewBox="0 0 25 25"
                      >
                        <path
                          stroke="#40b2aa"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeMiterlimit="10"
                          strokeWidth="1.5"
                          d="M2.998 13.477h17"
                        ></path>
                        <path
                          stroke="#40b2aa"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="1.5"
                          d="M19.998 11.146v7.15c-.03 2.85-.81 3.57-3.78 3.57h-9.44c-3.02 0-3.78-.75-3.78-3.73v-6.99c0-2.7.63-3.57 3-3.71.24-.01.5-.02.78-.02h9.44c3.02 0 3.78.75 3.78 3.73z"
                        ></path>
                        <path
                          stroke="#40b2aa"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="1.5"
                          d="M22.998 7.597v6.99c0 2.7-.63 3.57-3 3.71v-7.15c0-2.98-.76-3.73-3.78-3.73h-9.44c-.28 0-.54.01-.78.02.03-2.85.81-3.57 3.78-3.57h9.44c3.02 0 3.78.75 3.78 3.73z"
                          opacity="0.4"
                        ></path>
                        <path
                          stroke="#40b2aa"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeMiterlimit="10"
                          strokeWidth="1.5"
                          d="M6.248 18.677h1.72M10.107 18.677h3.44"
                          opacity="0.4"
                        ></path>
                      </svg>
                    </div>
                    <div className="textPossibilityOfPayment">
                      <span>امکان پرداخت در محل</span>
                    </div>
                  </div>
                  <div className="medalStar">
                    <div className="imagemedalStar">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="none"
                        viewBox="0 0 25 25"
                      >
                        <path
                          stroke="#40b2aa"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="1.5"
                          d="M19.998 9.867c0 1.45-.43 2.78-1.17 3.89a6.985 6.985 0 01-4.78 3.02c-.34.06-.69.09-1.05.09-.36 0-.71-.03-1.05-.09a6.985 6.985 0 01-4.78-3.02 6.968 6.968 0 01-1.17-3.89c0-3.87 3.13-7 7-7s7 3.13 7 7z"
                        ></path>
                        <path
                          stroke="#40b2aa"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="1.5"
                          d="M22.247 19.337l-1.65.39c-.37.09-.66.37-.74.74l-.35 1.47a1 1 0 01-1.74.41l-4.77-5.48-4.77 5.49a1 1 0 01-1.74-.41l-.35-1.47a.996.996 0 00-.74-.74l-1.65-.39a1.003 1.003 0 01-.48-1.68l3.9-3.9a6.985 6.985 0 004.78 3.02c.34.06.69.09 1.05.09.36 0 .71-.03 1.05-.09 1.99-.29 3.7-1.42 4.78-3.02l3.9 3.9c.55.54.28 1.49-.48 1.67zM13.578 6.847l.59 1.18c.08.16.29.32.48.35l1.07.18c.68.11.84.61.35 1.1l-.83.83c-.14.14-.22.41-.17.61l.24 1.03c.19.81-.24 1.13-.96.7l-1-.59a.701.701 0 00-.66 0l-1 .59c-.72.42-1.15.11-.96-.7l.24-1.03c.04-.19-.03-.47-.17-.61l-.83-.83c-.49-.49-.33-.98.35-1.1l1.07-.18c.18-.03.39-.19.47-.35l.59-1.18c.29-.64.81-.64 1.13 0z"
                          opacity="0.4"
                        ></path>
                      </svg>
                    </div>
                    <div className="textmedalStar">
                      <span>ضمانت اصل بودن کالا</span>
                    </div>
                  </div>
                </div>
                <div className="columnResponsive">
                  <div className="Support">
                    <div className="imageSupport">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="25"
                        height="25"
                        fill="none"
                        viewBox="0 0 25 25"
                      >
                        <path
                          stroke="#40b2aa"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeMiterlimit="10"
                          strokeWidth="1.5"
                          d="M18.998 19.726h-.76c-.8 0-1.56.31-2.12.87l-1.71 1.69c-.78.77-2.05.77-2.83 0l-1.71-1.69c-.56-.56-1.33-.87-2.12-.87h-.75c-1.66 0-3-1.33-3-2.97V5.846c0-1.64 1.34-2.97 3-2.97h12c1.66 0 3 1.33 3 2.97v10.91c0 1.63-1.34 2.97-3 2.97z"
                        ></path>
                        <path
                          stroke="#40b2aa"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth="1.5"
                          d="M7.998 10.027c0-.93.76-1.69 1.69-1.69.93 0 1.69.76 1.69 1.69 0 1.88-2.67 2.08-3.26 3.87-.12.37.19.74.58.74h2.68M17.037 14.627v-5.71a.58.58 0 00-.42-.56.593.593 0 00-.66.25c-.72 1.16-1.5 2.48-2.18 3.64-.11.19-.11.44 0 .63s.32.31.55.31h3.67"
                          opacity="0.4"
                        ></path>
                      </svg>
                    </div>
                    <div className="textSupport">
                      <span>7روز هفته ، 24ساعته</span>
                    </div>
                  </div>


                </div>
              </div>
              {/* <div className="selectBoxColorAndSize">
                <div className="selectColor">
                  <label>رنگ</label>
                  <select
                    value={selectedColor}
                    onChange={(e) => setSelectedColor(e.target.value)}
                  >
                    <option value="">انتخاب رنگ</option>
                    {data.options.map((option, index) => (
                      <option key={index} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="selectSize">
                  <label>سایز</label>
                  <select
                    value={selectedSize}
                    onChange={(e) => setSelectedSize(e.target.value)}
                  >
                    <option value="">انتخاب سایز</option>
                    {data.option.map((option, index) => (
                      <option key={index} value={option}>
                        {option}
                      </option>
                    ))}
                  </select>
                </div>
              </div> */}
              <div className="rowquantityAndPrice responsive_mrg">
                <div className="selectquantity">
                  <label>
                    {productInfo.type === "1" ? "تعداد محصول" : "مقدار محصول"}
                  </label>

                  <div className="widget-add-item">
                    <div className="box-counter">
                      <button
                        className="icon-box"
                        id="up"
                        onClick={() => numHandler("up")}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="10"
                          height="10"
                          fill="none"
                          viewBox="0 0 10 10"
                        >
                          <g fill="#40B2AA" clipPath="url(#clip0_1128_20332)">
                            <path
                              d="M9 5.75H1C.59 5.75.25 5.41.25 5s.34-.75.75-.75h8c.41 0 .75.34.75.75s-.34.75-.75.75z"></path>
                            <path
                              d="M5 9.75c-.41 0-.75-.34-.75-.75V1c0-.41.34-.75.75-.75s.75.34.75.75v8c0 .41-.34.75-.75.75z"></path>
                          </g>
                          <defs>
                            <clipPath id="clip0_1128_20332">
                              <path fill="#fff" d="M0 0H10V10H0z"></path>
                            </clipPath>
                          </defs>
                        </svg>
                      </button>

                      <input
                        value={
                          productInfo.type === 1
                            ? currentNum
                            : currentNum.toFixed(1)
                        }
                        readOnly
                      />

                      <p>{productInfo.type === 1 ? "عدد" : "کیلوگرم"}</p>

                      <button
                        className="icon-box"
                        id="low"
                        style={{marginBottom: "5px"}}
                        onClick={() => numHandler("down")}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="10"
                          height="2"
                          viewBox="0 0 10 2"
                          fill="none"
                        >
                          <path
                            d="M9 1.75H1C0.59 1.75 0.25 1.41 0.25 1C0.25 0.59 0.59 0.25 1 0.25H9C9.41 0.25 9.75 0.59 9.75 1C9.75 1.41 9.41 1.75 9 1.75Z"
                            fill="#40B2AA"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                  {/* <select
                  value={selectedamount}
                  onChange={(e) => setSelectedamount(e.target.value)}
                >
                  <option value="">انتخاب وزن</option>
                  {data.quantity.map((quantity, index) => (
                    <option key={index} value={quantity}>
                      {quantity}
                    </option>
                  ))}
                </select> */}
                </div>
                <div className="qeimatAndTakhfif">
                  <div className="columnPrice">
                    <div className="Gheimat">
                      <p
                        style={
                          productInfo?.offer
                            ? {textDecorationLine: "line-through"}
                            : {}
                        }
                      >
                        {formatToPersianAddComma(Math.floor(+productInfo?.mainPrice * +currentNum)) + " ریال"}
                        {productInfo?.offerPrice === "0" && " ریال"}
                      </p>
                    </div>
                    <div className="ezafeGheimat">
                      <p>
                        {productInfo?.offerPrice !== 0 &&
                          formatToPersianAddComma(Math.floor((+productInfo?.mainPrice - +productInfo?.offerPrice) * +currentNum)) + " ریال"}{" "}
                      </p>
                    </div>
                  </div>
                  {productInfo?.discount !== "0" && (
                    <div className="Takhfif">
                      <p>{productInfo?.discount}%</p>
                    </div>
                  )}
                </div>
              </div>
              <div className="ButtonAdd">
                <button
                  ref={buttonRef}
                  id="fixed-button"
                  className={isFixed ? "fixed" : ""}
                  onClick={handleAddToCart}
                >
                  افزودن به سبدخرید
                </button>
              </div>
            </div>
          ) : (
            <div className="FormProduct">ناموجود</div>
          )}
          <div className="columnLeftProduct">
            {productInfo?.type === 2 && (
              <div className="weight-text">
                <p>
                  قیمت این محصول بر اساس وزن تعیین میشود.
                </p>

                <p style={{marginTop: 20}}>
                  در نظر داشته باشید که پس از ثبت سفارش وزن دقیق در فاکتور خرید شما اصلاح خواهد شد.
                </p>
              </div>
            )}
            <div className="PossibilityOfPayment">
              <div className="imagePossibilityOfPayment">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  fill="none"
                  viewBox="0 0 25 25"
                >
                  <path
                    stroke="#40b2aa"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeMiterlimit="10"
                    strokeWidth="1.5"
                    d="M2.998 13.477h17"
                  ></path>
                  <path
                    stroke="#40b2aa"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                    d="M19.998 11.146v7.15c-.03 2.85-.81 3.57-3.78 3.57h-9.44c-3.02 0-3.78-.75-3.78-3.73v-6.99c0-2.7.63-3.57 3-3.71.24-.01.5-.02.78-.02h9.44c3.02 0 3.78.75 3.78 3.73z"
                  ></path>
                  <path
                    stroke="#40b2aa"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                    d="M22.998 7.597v6.99c0 2.7-.63 3.57-3 3.71v-7.15c0-2.98-.76-3.73-3.78-3.73h-9.44c-.28 0-.54.01-.78.02.03-2.85.81-3.57 3.78-3.57h9.44c3.02 0 3.78.75 3.78 3.73z"
                    opacity="0.4"
                  ></path>
                  <path
                    stroke="#40b2aa"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeMiterlimit="10"
                    strokeWidth="1.5"
                    d="M6.248 18.677h1.72M10.107 18.677h3.44"
                    opacity="0.4"
                  ></path>
                </svg>
              </div>
              <div className="textPossibilityOfPayment">
                <span>امکان پرداخت در محل</span>
              </div>
            </div>

            <div className="Support">
              <div className="imageSupport">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  fill="none"
                  viewBox="0 0 25 25"
                >
                  <path
                    stroke="#40b2aa"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeMiterlimit="10"
                    strokeWidth="1.5"
                    d="M18.998 19.726h-.76c-.8 0-1.56.31-2.12.87l-1.71 1.69c-.78.77-2.05.77-2.83 0l-1.71-1.69c-.56-.56-1.33-.87-2.12-.87h-.75c-1.66 0-3-1.33-3-2.97V5.846c0-1.64 1.34-2.97 3-2.97h12c1.66 0 3 1.33 3 2.97v10.91c0 1.63-1.34 2.97-3 2.97z"
                  ></path>
                  <path
                    stroke="#40b2aa"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                    d="M7.998 10.027c0-.93.76-1.69 1.69-1.69.93 0 1.69.76 1.69 1.69 0 1.88-2.67 2.08-3.26 3.87-.12.37.19.74.58.74h2.68M17.037 14.627v-5.71a.58.58 0 00-.42-.56.593.593 0 00-.66.25c-.72 1.16-1.5 2.48-2.18 3.64-.11.19-.11.44 0 .63s.32.31.55.31h3.67"
                    opacity="0.4"
                  ></path>
                </svg>
              </div>
              <div className="textSupport">
                <span>7روز هفته ، 24ساعته</span>
              </div>
            </div>

            <div className="medalStar">
              <div className="imagemedalStar">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  fill="none"
                  viewBox="0 0 25 25"
                >
                  <path
                    stroke="#40b2aa"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                    d="M19.998 9.867c0 1.45-.43 2.78-1.17 3.89a6.985 6.985 0 01-4.78 3.02c-.34.06-.69.09-1.05.09-.36 0-.71-.03-1.05-.09a6.985 6.985 0 01-4.78-3.02 6.968 6.968 0 01-1.17-3.89c0-3.87 3.13-7 7-7s7 3.13 7 7z"
                  ></path>
                  <path
                    stroke="#40b2aa"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                    d="M22.247 19.337l-1.65.39c-.37.09-.66.37-.74.74l-.35 1.47a1 1 0 01-1.74.41l-4.77-5.48-4.77 5.49a1 1 0 01-1.74-.41l-.35-1.47a.996.996 0 00-.74-.74l-1.65-.39a1.003 1.003 0 01-.48-1.68l3.9-3.9a6.985 6.985 0 004.78 3.02c.34.06.69.09 1.05.09.36 0 .71-.03 1.05-.09 1.99-.29 3.7-1.42 4.78-3.02l3.9 3.9c.55.54.28 1.49-.48 1.67zM13.578 6.847l.59 1.18c.08.16.29.32.48.35l1.07.18c.68.11.84.61.35 1.1l-.83.83c-.14.14-.22.41-.17.61l.24 1.03c.19.81-.24 1.13-.96.7l-1-.59a.701.701 0 00-.66 0l-1 .59c-.72.42-1.15.11-.96-.7l.24-1.03c.04-.19-.03-.47-.17-.61l-.83-.83c-.49-.49-.33-.98.35-1.1l1.07-.18c.18-.03.39-.19.47-.35l.59-1.18c.29-.64.81-.64 1.13 0z"
                    opacity="0.4"
                  ></path>
                </svg>
              </div>
              <div className="textmedalStar">
                <span>ضمانت اصل بودن کالا</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddToShoppingBag;
